<template>
    <div v-if="news.length > 2" class="about-section">
        <div class="section-container container main-container">
            <div class="about-section__header section__header-title--spacing">
                <span class="title welcome__title title--m title--uppercase">издания пишут о «коде памяти»</span>
            </div>
<!--large-->
            <div v-if="news.length > 2" class="about-section__news">
                <div class="about-section__item" v-for="item in news" :key="item.id">
                    <NewsMainPage :article="item"/>
                </div>

                <div class="about-section__btn-wrapper">
                    <a type="button" class="btn btn--main-bg btn--middle btn--w100" @click="routeToLink">Смотреть все</a>
                </div>
            </div>
<!--medium-->
            <div v-if="news.length > 2" class="about-section__news--medium">
                <div class="about-section__news-wrapper">
                    <div class="about-section__item about-section__item--medium" v-for="item in getChunkedNewsMedium" :key="item.id">
                        <NewsMainPage :article="item"/>
                    </div>
                </div>

                <div class="about-section__btn-wrapper about-section__btn-wrapper--medium">
                    <a type="button" class="btn btn--main-bg btn--middle btn--w100 about-section__news-link" @click="routeToLink">Смотреть все</a>
                    <div class="about-section__news--btn-wrapper">
                        <button class="btn btn--main-bg about-section__page-btn" @click="decMediumPage">
                            <img src="/assets/front/img/arrow-small-left.svg" alt="img">
                        </button>

                        <button class="btn btn--main-bg about-section__page-btn" @click="incMediumPage">
                            <img src="/assets/front/img/arrow-small-right.svg" alt="img">
                        </button>
                    </div>
                </div>
            </div>
<!--small-->
            <div v-if="news.length > 2" class="about-section__news--small">
                <div class="about-section__news-wrapper">
                    <div class="about-section__item" v-for="item in getChunkedNewsSmall" :key="item.id">
                        <NewsMainPage :article="item"/>
                    </div>
                </div>

                <div class="about-section__btn-wrapper">
                    <a type="button" class="btn btn--main-bg btn--middle btn--w100" @click="routeToLink">Смотреть все</a>
                    <div class="about-section__news--btn-wrapper">
                        <button class="btn btn--main-bg about-section__page-btn" @click="decSmallPage">
                            <img src="/assets/front/img/arrow-small-left.svg" alt="img">
                        </button>

                        <button class="btn btn--main-bg about-section__page-btn" @click="incSmallPage">
                            <img src="/assets/front/img/arrow-small-right.svg" alt="img">
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "../../api/api";
import NewsMainPage from "../news/NewsMainPage";
import _ from "lodash";

export default {
    name: 'WelcomeAboutUs',
    components: { NewsMainPage },
    data() {
        return {
            news: [],

            pageMedium: 1,
            pageCountMedium: 0,

            pageSmall: 1,
            pageCountSmall: 0,
        }
    },
    created() {
        this.getNews();
    },
    methods: {
        routeToLink() {
            window.open('/news/smi-o-nas');
        },
        getNews() {
            ApiService.get('/news/about-us')
                .then(res => {
                    this.news = res.data;
                })
                .catch(err => console.log(err))
        },
        incMediumPage() {
            if(this.pageMedium === this.pageCountMedium) {
                this.pageMedium = 1;
                return;
            }
            if(this.pageMedium < this.pageCountMedium) this.pageMedium++;
        },
        decMediumPage() {
            if(this.pageMedium === 1) {
                this.pageMedium = this.pageCountMedium;
                return;
            }
            if(this.pageMedium > 1) this.pageMedium--;
        },
        incSmallPage() {
            if(this.pageSmall === this.pageCountSmall) {
                this.pageSmall = 1;
                return;
            }
            if(this.pageSmall < this.pageCountSmall) this.pageSmall++;
        },
        decSmallPage() {
            if(this.pageSmall === 1) {
                this.pageSmall = this.pageCountSmall;
                return;
            }
            if(this.pageSmall > 1) this.pageSmall--;
        },
    },
    computed: {
        getChunkedNewsMedium() {
            if(this.news.length) {
                const chunks = _.chunk(this.news, 2);
                this.pageCountMedium = chunks.length;
                return chunks[this.pageMedium - 1] || this.news;
            }
        },
        getChunkedNewsSmall() {
            if(this.news.length) {
                const chunks = _.chunk(this.news, 1);
                this.pageCountSmall = chunks.length;
                return chunks[this.pageSmall - 1] || this.news;
            }
        }
    },
}
</script>
